<template>
  <div class="dataTables_wrapper form-inline dt-bootstrap" id="example1_wrapper">
    <div class="row">
      <div class="col-sm-6 text-left">
        <div class="form-group text-left">
          <div class="btn btn-default btn-table-title" @click="outputList">{{orderSn?'匯出單筆拆帳訂單':'匯出單日店家所有拆帳'}}</div>
        </div>
      </div>
      <!--<div class="col-sm-6 text-right">-->
        <!--<div class="form-group">-->
          <!--<select class="form-control h-38" v-model="searchSelect">-->
            <!--<option value="1">時間</option>-->
          <!--</select>-->
        <!--</div>-->
        <!--<div class="form-group input-group time-box" v-if="searchSelect == 1">-->
          <!--<date-time-picker :date="menuTime.start" :option="dateoption" :limit="startLimit"></date-time-picker>-->
          <!--<date-time-picker :date="menuTime.end" :option="dateoption" :limit="endLimit"></date-time-picker>-->
          <!--&lt;!&ndash;<input type="text" class="form-control time-picker" id="start-box" placeholder="起始時間">&ndash;&gt;-->
          <!--&lt;!&ndash;<input type="text" class="form-control time-picker" id="end-box" placeholder="結束時間">&ndash;&gt;-->
          <!--<span class="input-group-btn">-->
            <!--<button class="btn btn-default submit-btn btn-search" type="button"-->
                    <!--id="search" style="height: 72px" @click="getRangeHistory(1)">-->
              <!--<i class="fa fa-search"></i>-->
            <!--</button>-->
          <!--</span>-->
        <!--</div>-->
      <!--</div>-->
    </div>
    <div class="row">
      <div class="col-xs-12" v-if="info.brandId">
        <div class="box-body form-left min-m-t-10">
          <div>
            <div class="input-group">
              <span class="input-group-addon">品牌名稱(ID)</span>
              <div class="form-control form-info">
                {{info.brandName}} ({{info.brandId}})
              </div>
            </div>
            <br />
          </div>
        </div>
        <div class="box-body form-right min-m-t-10">
          <div>
            <div class="input-group">
              <span class="input-group-addon">店家名稱(ID)</span>
              <div class="form-control form-info">
                {{info.storeName}} ({{info.storeId}})
              </div>
            </div>
            <br />
          </div>
        </div>
      </div>
      <div class="col-sm-12 table-responsive p-x-0">
        <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
          <thead>
          <tr role="row">
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">#</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">下訂日期</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">訂單編號</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">訂單ID</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">總杯數</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">總交易金額</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">店家實得款項金額</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">Matcher手續費</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">授權成功</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">取款</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">給付</th>
          </tr>
          </thead>
          <tbody>
          <tr class="even" role="row" v-for="(history, index) in historyList">
            <td class="sorting_1">
              <router-link :to="{path: '/historyOrderInfo/' + history.order_id}">
                <span>{{index + 1}}</span>
              </router-link>
            </td>
            <td>{{history.order_date}}</td>
            <td>{{history.order_sn}}</td>
            <td>{{history.order_id}}</td>
            <td>{{history.product_amount}}</td>
            <td>$ {{history.order_money}}</td>
            <td>$ {{history.store_revenue}}</td>
            <td>$ {{history.matcher_revenue}}</td>
            <td>
              <span v-if="history.is_authenticated" class="label label-success">成功</span>
              <span v-if="!history.is_authenticated"  class="label label-danger">失敗</span>
            </td>
            <td>
              <span v-if="history.is_posted" class="label label-success">成功</span>
              <span v-if="!history.is_posted"  class="label label-danger">失敗</span>
            </td>
            <td>
              <span v-if="history.is_store_paid" class="label label-success">成功</span>
              <span v-if="!history.is_store_paid"  class="label label-danger">失敗</span>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="col-xs-12 text-center">
        <ul class="pagination">
          <li class="paginate_button" v-for="index in pageAmount" :class="{active: isActive(index)}" @click="clickPage(index)">
            <a class="c-pointer">{{index}}</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'

export default{
  data () {
    return {
      orderSn: this.$route.params.order_sn,
      total: 1,
      count: 20,
      historyList: [],
      tableIndex: 1,
      searchSelect: 1,
      storeId: this.$route.params.store_id,
      date: this.$route.params.date,
      info: {
        brandId: '',
        brandName: '',
        storeId: '',
        storeName: ''
      }
    }
  },
  methods: {
    isActive (index) {
      if (this.tableIndex === index) return true
      else return false
    },
    getDailyHistory (index) {
      var self = this
      var info = this.info
      if (index) this.tableIndex = index
      var date = moment(this.date, 'YYYY-MM-DD').format('YYYYMMDD')
      var url = 'history/dailyHistory' + '?page=' + this.tableIndex + '&size=' + this.count + '&date=' + date + '&store_id=' + this.storeId
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.historyList = response.data.history_list
          self.total = response.data.total
          if (self.historyList.length) {
            for (let key in self.historyList) {
              info.brandId = self.historyList[key].brand_id
              info.brandName = self.historyList[key].brand_name
              info.storeId = self.historyList[key].store_id
              info.storeName = self.historyList[key].store_name
              break
            }
          }
        }
      })
    },
    getOrderHistory () {
      var self = this
      var info = this.info
      var url = 'history/orderHistory/' + this.orderSn
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          const historyList = [response.data.history]
          self.historyList = historyList
          // self.total = response.data.total
          if (self.historyList.length) {
            info.brandId = self.historyList[0].brand_id
            info.brandName = self.historyList[0].brand_name
            info.storeId = self.historyList[0].store_id
            info.storeName = self.historyList[0].store_name
          }
        }
      })
    },
    outputList () {
      var date = moment(this.date, 'YYYY-MM-DD').format('YYYYMMDD')
      var url
      const path = this.$route.name
      if (path === 'oneDayHistory') url = 'history/orderHistorySheets/' + this.orderSn
      else url = 'history/dailyHistorySheets' + '?page=' + this.tableIndex + '&size=' + this.count + '&date=' + date + '&store_id=' + this.storeId
      this.getFile('get', url, null, function (response) {
        // window.location = response
        var blob = new Blob([response.data], {type: 'application/vnd.ms-excel'})
        var objectUrl = URL.createObjectURL(blob)
        var a = document.createElement('a')
        a.href = objectUrl
        if (path === 'oneDayHistory') a.download = '單日店家所有拆帳.xls'
        else a.download = '單筆訂單拆帳.xls'
        document.body.appendChild(a)
        a.click()
      })
    },
    clickPage (index) {
      this.tableIndex = index
      const path = this.$route.name
      if (path === 'oneDayHistory') this.getOrderHistory()
      else this.getDailyHistory()
    }
  },
  created () {
    const path = this.$route.name
    if (path === 'oneDayHistory') this.getOrderHistory()
    else this.getDailyHistory()
  },
  computed: {
    getDataH () {
      return this.$parent.getDataH
    },
    pageAmount () {
      return Math.ceil(this.total / this.count)
    },
    getFile () {
      return this.$parent.getFile
    }
  }
}
</script>



// WEBPACK FOOTER //
// OneDayHistoryTableTemp.vue?7d264842